import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconImagine: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconImagine"><Path d="M6.5 22V15.7506C4.57317 14.4355 3.5 12.2506 3.5 9.77751C3.5 5.75825 6.82988 2.5 10.9375 2.5C15.0451 2.5 18.45 5.75825 18.45 9.77751L20.5 13.25L18.5 14.4559V17.5C18.5 18.0523 18.0523 18.5 17.5 18.5H13.5313V22" stroke="currentColor"/><Path d="M11.35 6.5H10.65L9.775 8.775L7.5 9.65V10.35L9.775 11.225L10.65 13.5H11.35L12.225 11.225L14.5 10.35V9.65L12.225 8.775L11.35 6.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconImagine;
